import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {  deleteIdData } from "../../../lib/studentnotes"
import { getStudentIdData } from "../../../lib/instructorstudentnotesview"
import {getInstructorStudent} from "../../../lib/instructorstudentview";
import {getInstructorStudent as getInstructorData} from "../../../lib/instructorstudentnotesview";
import { useAuth } from "../../../usercontext";

export default function InstructorNotes() {

  const [notes, setNotes] = useState([])
  const [selectedStudent, setSelectedStudent] = useState("All");
  const [instructorStudent, setInstructorStudent] = useState([]);
  const { profile } = useAuth();

  const slug = profile.id;
  const cls =  profile.class;

  const handleDelete = async (id) => {
    const choice = window.confirm(
      'Are You Sure?'
    );
    if (choice) {
      await deleteIdData(id);
      //getDataWithTypeFromParamter();
      //console.log("Delete", id);
      if (selectedStudent != "All")
        GetStudentData(selectedStudent);
      else
        GetAllData();
    }

  };

  async function GetAllData() {
    const note = await getInstructorData(profile.id);
    setNotes(note);
    console.log("note",note);
  }


  async function GetInstructorStudentData() {
    const students = await getInstructorStudent(profile.id);
    setInstructorStudent(students);
  }

  async function GetStudentData() {
   const note = await getStudentIdData(selectedStudent);
      //console.log("lesson",lesson.filter(cat => cat.class == catg));
      setNotes(note);
  }

  useEffect(() => {
    if (selectedStudent != "All")
    GetStudentData(selectedStudent);
  else
    GetAllData();
  }, [selectedStudent])

  useEffect(() => {
    if (selectedStudent != "All")
      GetStudentData(selectedStudent);
    else
      GetAllData();
    GetInstructorStudentData();
  }, [])

  return (
            <div className="col-xl-9 col-md-8 mx-auto">
              <div className="settings-widget profile-details">
                <div className="settings-inner-blk p-0">
                  <div className="profile-heading">
                    <h3>Notes</h3>
                    <div className="new-address">
                      <div className="row">
                        <div className="col">
                        </div>
                        <div className="col"> </div>
                        <div className="col">
                          <Link
                            to={`/instructor/instructor-notes-edit/Add/${selectedStudent}/Main`}
                            className={selectedStudent ==="All" ? `btn btn-dark btn-dark-1 disabled`: `btn btn-dark btn-dark-1` }
                          >
                            Add New Note
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="category-tab tickets-tab-blk">
                    <div className="w-50 m-4">
                                <h5>Students</h5>
                                <div className="select-container">
                                    <select
                                        value={selectedStudent}
                                        onChange={e => setSelectedStudent(e.target.value)}
                                        className="select-box" >
                                          <option key="aa" value="All">All</option>
                                        {instructorStudent.map(function (data, ix) {
                                            return (
                                                <option key={ix} value={data.studentId}>{data.name + " " + data.surname}</option>
                                            )
                                        })}
                                    </select>
                                    <div className="icon-container">
                                        <i className="fa-solid fa-chevron-down"></i>
                                    </div>
                                </div>
                            </div>
                  </div>
                  <div className="comman-space pb-0">
                    <div className="settings-invoice-blk table-responsive">
                      {/* Invoice info */}
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Regarding</th>
                            <th>Student</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {notes.map(function (data) {
                            return (
                              <tr key={data.id}>
                                <td>
                                  <Link
                                    to="#"
                                    className="invoice-no"
                                  >
                                    {data.id}
                                  </Link>
                                </td>
                                <td>{data.title}</td>
                                <td>{data.name + " " + data.surname}</td>
                                <td>
                                  <div className="profile-share d-flex align-items-center justify-content-end">
                                    <Link to={`/instructor/instructor-notes-edit/Update/${data.id}/Main`} className="btn btn-success btn-sm">
                                      Update  
                                    </Link>

                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      {/* Invoice info */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
